module.exports = __webpack_public_path__ + "static/media/NB-MX5.c17355d2.webp";